import React, { useState, useEffect, useCallback } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Row, Col, Card, CardBody, Button } from 'reactstrap';
import { MDBDataTable } from 'mdbreact';
import SweetAlert from 'react-bootstrap-sweetalert';

import { activateAuthLayout } from '../../../../store/actions';
import { connect } from 'react-redux';
import { gql } from 'apollo-boost';
import { useMutation, useQuery } from '@apollo/react-hooks';

const BUNDLES = gql`
    query getBundles {
        Bundles {
            BundleId
            Name
            Description
        }
    }
`;

const DELETE_BUNDLE = gql`
  mutation deleteBundle($BundleId: ID!) {
    deleteBundle(BundleId: $BundleId) {
      BundleId
    }
  }
`;

const BundleList = ({ activateAuthLayout, ...props }) => {
  useEffect(() => { activateAuthLayout(); }, [activateAuthLayout]);

  const history = useHistory();
  const location = useLocation();
  const currentQuoteParam = location.search && location.search.includes('?currentQuote=') ? `?currentQuote=${location.search.split('=').pop()}` : '';

  // initialize states
  const [bundlesData, setBundlesData] = useState(null)

  // initialize apollo graphql queries and mutations
  const { data, refetch } = useQuery(BUNDLES);
  const [deleteBundle] = useMutation(DELETE_BUNDLE);
  const [deleteBundleId, setDeleteBundleId] = useState(null);

  const createNewBundle = (e) => {
    e.preventDefault();
    history.push(`/admin/bundle/create${currentQuoteParam}`);
  }

  const editBundle = useCallback((e, bundleId) => {
    e.preventDefault();
    history.push(`/admin/bundle/edit/${bundleId}${currentQuoteParam}`);
  }, [history, currentQuoteParam]);

  const deleteBundleItem = () => {
    deleteBundle({
      variables: { BundleId: deleteBundleId }
    }).then(() => refetch());
    setDeleteBundleId(null);
  }

  // component mounted/willmount
  useEffect(() => {
    if (data) {
      const bundles = data.Bundles.map((bundle, index) => {
        return {
          Name: bundle.Name,
          Description: bundle.Description,
          Action:
            <div>
              <Button color="info" size="sm" className="mr-2" onClick={(e) => editBundle(e, bundle.BundleId)}>Edit</Button>
              <Button color="danger" size="sm" onClick={(e) => setDeleteBundleId(bundle.BundleId)}>Delete</Button>
            </div>
        }
      }
      )
      setBundlesData({
        columns: [
          {
            label: ['Bundle Name', <i key={`bundle-name`} className="fa fa-sort ml-2"></i>],
            field: 'Name',
            sort: 'asc',
          },
          {
            label: ['Description', <i key={`bundle-description`} className="fa fa-sort ml-2"></i>],
            field: 'Description',
            sort: 'asc',
          },
          {
            label: 'Action',
            field: 'Action',
            sort: 'disabled'
          }
        ],
        rows: bundles
      });
    }
  }, [data, editBundle]);

  return (
    <React.Fragment>
      {
        <div className="content">
          <div className="container-fluid">
            <div className="page-title-box">
              <Row className="align-items-center">
                <Col sm="6">
                  <h4 className="page-title">Bundles</h4>
                </Col>
                <Col sm="6" className="text-right">
                  <Button color="success" onClick={createNewBundle} >Create New Bundle</Button>
                </Col>
              </Row>
            </div>
            {deleteBundleId &&
              <SweetAlert
                warning
                title="Confirm"
                onConfirm={deleteBundleItem}
                onCancel={() => setDeleteBundleId(null)}
                showCancel
                showConfirm
                confirmBtnText="Delete"
                cancelBtnText="Cancel"
                confirmBtnBsStyle="danger"
                cancelBtnBsStyle="secondary"
              >
                Are you sure you want to delete this bundle?
              </SweetAlert>
            }
            <Row>
              <Col lg="12">
                <Card>
                  <CardBody>
                    {data && bundlesData &&
                      <MDBDataTable
                        sortable
                        striped
                        borderless
                        theadColor="table-dark"
                        hover
                        responsive
                        noBottomColumns
                        noRecordsFoundLabel={'No bundles found'}
                        order={['Name', 'asc']}
                        data={bundlesData}
                      />
                    }
                  </CardBody>
                </Card>
              </Col>
            </Row>

          </div>
        </div>
      }
    </React.Fragment>
  );
}

export default connect(null, { activateAuthLayout })(BundleList);